<template>
	<div class="section_wrap">
		<h6 class="--blue70">
			{{ $t( 'report.components.expert_opinion' ) }}
    </h6>
		<div class="section_body">
			<KvTable class="table" :items="expertOpinionSectionItems"/>
		</div>
	</div>
</template>
<script>
//expert opinion 상세보기 섹션.
import KvTable from '@/components/Table/kvTable'
import { _EXPERT_OPINION_SECTION_TABLE } from
        "@/components/body/myPatient/report/reportItem/expertOpinionSection/lib"
import { mapActions } from 'vuex'

export default {
  name: "ExpertOpinionSection",
  components: {KvTable},
  data() {
    return {
      expertOpinionSectionItems: new _EXPERT_OPINION_SECTION_TABLE(this),
    }
  },
  methods: {
    ...mapActions(['updateExpertOpinionData']),
  },
  mounted() {
    this.expertOpinionSectionItems[0].parentClass = ['columns_4'];
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'resetReportToVuex' || mutation.type === 'setExpertOpinionDataToVuex')
        this.expertOpinionSectionItems[0].values = state.report.expertOpinionData;
    })
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  watch: {
    expertOpinionSectionItems: {
      deep: true,
      handler(newData) {
        this.updateExpertOpinionData(newData[0].values);
      }
    },
  }
}
</script>
<style lang="scss">

</style>